import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var QuickbooksWhiteSvg = function QuickbooksWhiteSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#28A038",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.174 8.486v9.73H10.09V9.583H8.5c-1.387 0-2.717 1.428-2.717 2.86 0 1.394 1.293 2.515 2.717 2.515h.513v1.095h-.555c-2.174 0-3.755-1.424-3.755-3.61S6.326 8.486 8.5 8.486zm2.174-2.162v8.628h1.567c1.387 0 2.739-1.279 2.739-2.71 0-1.395-1.315-2.653-2.704-2.676q-.062.008-.143.012l-.158.007c-.13.004-.238.004-.238.004V8.486s.391-.032.539 0c2.139-.032 3.807 1.57 3.807 3.755 0 2.186-1.668 3.838-3.842 3.838h-2.662V6.324z",
    clipRule: "evenodd"
  }));
};
export var QuickbooksWhite = function QuickbooksWhite(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: QuickbooksWhiteSvg
  }));
};